import { useState } from 'react';
import { AppBundle } from '../utils/app-bundles';
import { APP_EXTERNAL_UI_URLS, getAppExternalOverrides } from '../utils/dev-helper';
import { useMountEffect } from './state/use-mount-effect';

export function useInjectImportShim() {
  const [isLoaded, setIsLoaded] = useState(false);

  useMountEffect(() => {
    async function load() {
      const importMap = {
        imports: {
          [AppBundle.Pipelines]:
            import.meta.env.VITE_PIPELINES_ENTRYPOINT_JS_URL ?? 'http://localhost:3002/cdp/entrypoint.js',
          [AppBundle.Journeys]:
            import.meta.env.VITE_JOURNEYS_ENTRYPOINT_JS_URL ?? 'http://localhost:3002/entrypoint.js',
          [AppBundle.DesignStudio]:
            import.meta.env.VITE_DESIGN_STUDIO_ENTRYPOINT_JS_URL ?? 'http://localhost:3002/design-studio/entrypoint.js',
        },
      };

      if (import.meta.env.DEV === true || import.meta.env.VITE_ENABLE_EXTERNAL_UI_OVERRIDES === 'true') {
        const externalUiOverrides = getAppExternalOverrides();
        for (const [app, enabled] of Object.entries(externalUiOverrides) as [AppBundle, boolean][]) {
          if (enabled === true) {
            importMap.imports[app] = APP_EXTERNAL_UI_URLS[app];
          }
        }
      }

      window.importShim?.addImportMap(importMap);

      if (import.meta.env.VITE_ENABLE_EXTERNAL_UI_OVERRIDES === 'true') {
        // TODO: Figure out if we can actually import the refresh runtime
        // correctly. We can't in production-like builds, due to
        // https://github.com/facebook/react/blob/ce6842d8f528977119b80d969306c8475099f66e/packages/react-refresh/src/ReactFreshRuntime.js#L38-L42
        // const runtime = await import('react-refresh/runtime');
        // runtime.injectIntoGlobalHook(window);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        (window as unknown as { $RefreshReg$: () => void }).$RefreshReg$ = () => {};
        (window as unknown as { $RefreshSig$: () => (type: unknown) => unknown }).$RefreshSig$ =
          () => (type: unknown) =>
            type;
        // This is needed in case a developer runs the external Hydra UI, but
        // works on a vite-built React app on localhost. Much like in the
        // scenario described at https://vitejs.dev/guide/backend-integration.html
        (
          window as unknown as { __vite_plugin_react_preamble_installed__: boolean }
        ).__vite_plugin_react_preamble_installed__ = true;
      }

      setIsLoaded(true);
    }

    load();
  });

  return isLoaded;
}
